
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as run_45evalatXbv_L2h8jWiWGykSilI1p8Py_G4T5LzeBYo8cIaewMeta } from "/app/app/pages/developer/ai/run-eval.vue?macro=true";
import { default as toolsAEMtgpDusaSV8GInO2MnhIgvC2hhzwww9Iox_wJEOlMMeta } from "/app/app/pages/developer/ai/tools.vue?macro=true";
import { default as admin8RIdA2Ixao28P29uifxPEmy77bD6vQYb03cqFe6hVPMMeta } from "/app/app/pages/developer/api/admin.vue?macro=true";
import { default as appDc_ozAjZ_sNADGHkiOaq9F66HVRiR7eTYbPvFXJV16AMeta } from "/app/app/pages/developer/api/app.vue?macro=true";
import { default as b2bI2JTGrlMmXEifysoS5MqQPGC8qs9aiNETCneEuYANukMeta } from "/app/app/pages/developer/api/b2b.vue?macro=true";
import { default as b2b_45v2Q0vu1EZQCIkL6MU0VFV_jtPjtSx_Ofv2Hg0mXeW6cFAMeta } from "/app/app/pages/developer/api/b2b-v2.vue?macro=true";
import { default as connectXHnQtDPS924mUPs6n81HQ_QLuPmohV4urCQyekJto_UMeta } from "/app/app/pages/developer/api/connect.vue?macro=true";
import { default as miho40srN2p_NVIdvz4ZP7bmb92_rdYCPTx4HmmTtXTyFMMeta } from "/app/app/pages/developer/api/mih.vue?macro=true";
import { default as pdfeti_EK2qh9TTwSYnBJWFjZxY7_HAaok8cu7vh_D4b_kMeta } from "/app/app/pages/embed/advisor/[org_id]/portfolio-builder/pdf.vue?macro=true";
import { default as index6eTU3gEqJRH80AiO4TXqdAA1f_h0SAI0aw_crKxyyYsMeta } from "/app/app/pages/embed/advisor/[org_id]/portfolio-builder/index.vue?macro=true";
import { default as _91id_938fKS6NCYkbg6rL883FzdTbdmKqUu2bJid1ov9V53nKYMeta } from "/app/app/pages/developer/ai/[id].vue?macro=true";
import { default as _91id_93zzFCNlBnokH8j8X_qolTroP9DTN25FPXVNqniY3d1G8Meta } from "/app/app/pages/developer/maintenance/[id].vue?macro=true";
import { default as indexoL1Vtz0EZ0sCxYkTsLvo8_dKJ8ukdGCWa4ccmZAZhZQMeta } from "/app/app/pages/developer/ai/index.vue?macro=true";
import { default as client_45details2GzqUu0iE1D_NN7mhFWhErgsUtmAurP7ev8vXYhviosMeta } from "/app/app/pages/developer/client-details.vue?macro=true";
import { default as component_45galleryv5F9UAvyraRXaMMzu9K6Ae4pcdJTkOntILGAJwPv54IMeta } from "/app/app/pages/developer/component-gallery.vue?macro=true";
import { default as data_45reportsC0XDdP5gJrjakUKzjCABLfYI1K_Aare_qKPsIIZpBiQMeta } from "/app/app/pages/developer/data-reports.vue?macro=true";
import { default as data_45sessionsSZ8UeMLh9uvaT7Wbz5i3m_58_Uv15kbJCwxYVcWS7u8Meta } from "/app/app/pages/developer/data-sessions.vue?macro=true";
import { default as embedezdD_a6EC3GSPM4npTlddm_RxsmrXSheEHjJAOos_AsMeta } from "/app/app/pages/developer/embed.vue?macro=true";
import { default as holdings_45reportdNjogzmnrSiCFiFAtn3jh9FXqxph8DHMEzWeyIEmQ5EMeta } from "/app/app/pages/developer/holdings-report.vue?macro=true";
import { default as instrument_45detailshU4NR1ADzX1a0zfj5DKf8Af_FHtFtM_wSNn1N2dMti0Meta } from "/app/app/pages/developer/instrument-details.vue?macro=true";
import { default as instrument_45issuesKmfK58bE1w_rASMPLsCoXZgSPQDIk_xBv0WpCFF_8agMeta } from "/app/app/pages/developer/instrument-issues.vue?macro=true";
import { default as instrument_45list0Faubr0luTsCbJeBb3UkQ2hviWfqwDE0QMZNmuNElYEMeta } from "/app/app/pages/developer/instrument-list.vue?macro=true";
import { default as integration_45testsXBaq45LloJXAHpZk1QpPnI4X_Uz13dnQzQw_j2u_SqUMeta } from "/app/app/pages/developer/integration-tests.vue?macro=true";
import { default as integration_45tests_45reportmYUVBQowdIyIgC0QgHK_blV9Lh0LY_XZmaVSS0pipC8Meta } from "/app/app/pages/developer/integration-tests-report.vue?macro=true";
import { default as loginHDi2XHV6t5wgi5ZIsE1Qps7YFhvpbI1L9Trkffa7Ea0Meta } from "/app/app/pages/developer/login.vue?macro=true";
import { default as indexeJew_SAgG9UrFYhzdvm7M73L3WEA4Vq_yiy62naIDZAMeta } from "/app/app/pages/developer/maintenance/index.vue?macro=true";
import { default as market_45datag_CeMLSvldIUJ_EtsclyNElzcOImhslS1zPnyXPafwoMeta } from "/app/app/pages/developer/market-data.vue?macro=true";
import { default as organizationsx94E7dqhE68Sk_cBy2RSgZJei3x8kF_Yo75VAVBiPAsMeta } from "/app/app/pages/developer/organizations.vue?macro=true";
import { default as portfolio_45datapwOr_fffJ6mOLmdLUouQztNjo5nnVoTfJ8bv2jivuiYMeta } from "/app/app/pages/developer/portfolio-data.vue?macro=true";
import { default as price_45anomaliesGsLFzMqDECf9yn86XPCOwQuM5TwrdivjYZzWD75eBzkMeta } from "/app/app/pages/developer/price-anomalies.vue?macro=true";
import { default as trigger_45tasknoXWIUuoqMmbQ9ETagzj0o_8wVUvLzRVEQ7Gr7nF6nYMeta } from "/app/app/pages/developer/trigger-task.vue?macro=true";
import { default as user_45detailsTgjvsSJql6gcRSo9AEgsZk47VxE5beAEKh2_jGljI_sMeta } from "/app/app/pages/developer/user-details.vue?macro=true";
import { default as user_45listAtyb83ThhclAUoZ_iHLvUxfho7m9H5LopOatupd51kYMeta } from "/app/app/pages/developer/user-list.vue?macro=true";
import { default as apin4EqGWUbQ9rgKVBTjxE3vj2pSNx_ok9qVNapqHu6P8UMeta } from "/app/app/pages/docs/api.vue?macro=true";
import { default as newHSpNmtD_Ulst0gnQ0JT3hF856X8B_vJNwfg7w3nrvx0Meta } from "/app/app/pages/advisor/[org_id]/analytics/reports/new.vue?macro=true";
import { default as appjuok_UjUXSYQAfdIjvWRLC_N6Q_8qA2WkjsSAOh_x2MMeta } from "/app/app/pages/advisor/[org_id]/manage/njorda/app.vue?macro=true";
import { default as newnNSjzc73WskL_YsmU3a1xr3mcodA87YvBGGP6yRRWvIMeta } from "/app/app/pages/advisor/[org_id]/manage/users/new.vue?macro=true";
import { default as editqiR0GEPfLQeQtmy9tIdVDB5H_C6WVhrDH4u3X84wITEMeta } from "/app/app/pages/advisor/[org_id]/manage/users/[user_id]/edit.vue?macro=true";
import { default as _91report_id_93K2JPE3C885asztl_PdvxfIvC5bRle64ryIl9cF66_KAMeta } from "/app/app/pages/advisor/[org_id]/analytics/reports/[report_id].vue?macro=true";
import { default as indexV4hCtGPMvJgJFYSfLF_ovwF22dfuEXtuMhCLITKt0d8Meta } from "/app/app/pages/advisor/[org_id]/manage/users/[user_id]/index.vue?macro=true";
import { default as _91id_93q_K5_wxkY7_sRiVRcBqaCZKYCJv7TFEMp9xwxhbW6vEMeta } from "/app/app/pages/client/[org_id]/portfolio-sharing/start/[id].vue?macro=true";
import { default as _91id_93Qguui0HqoEC7D_xDNzk81thn1OGKwCbWwC9P6bC1KjEMeta } from "/app/app/pages/client/[org_id]/portfolio-sharing/step-1/[id].vue?macro=true";
import { default as _91id_93eYUiz8CKd0XbCZC5jsBrY3jDu8xN_sJfmc7brXM_Jh4Meta } from "/app/app/pages/client/[org_id]/portfolio-sharing/step-2/[id].vue?macro=true";
import { default as _91id_93ojnSr2VLejvCfRIWm_dzbBjKIueqUUDoM31E6qN2GboMeta } from "/app/app/pages/product-demo/[org_id]/mb/report/[id].vue?macro=true";
import { default as _91id_93ldtR2WA8muEs3TlN0_caKj5GF5qfoXo0gbx3Kd1D5dUMeta } from "/app/app/pages/product-demo/[org_id]/mb/review/[id].vue?macro=true";
import { default as indexQOICDPbq4Gu86twmjGivB_i8VLoENmyKNbOKOKmaw8kMeta } from "/app/app/pages/advisor/[org_id]/analytics/reports/index.vue?macro=true";
import { default as newAQG2i4lgjMf8AAZUnbWlBB_R17u0a6ZyIUQNhfJHE_8Meta } from "/app/app/pages/advisor/[org_id]/clients/new.vue?macro=true";
import { default as indexekhNpJOHVRQ_KKv05stgmDxclAw_xwAxHR1aZzOVjogMeta } from "/app/app/pages/advisor/[org_id]/manage/asset-class-rules/index.vue?macro=true";
import { default as indexDF7hfdZl560pWMFqz_xY5LPx6q_PPTRo06aG0PNGjE4Meta } from "/app/app/pages/advisor/[org_id]/manage/asset-classes/index.vue?macro=true";
import { default as indexPNfkdRK95UUzJR7H32997zO3dIuclrp_eLmOUKGOua0Meta } from "/app/app/pages/advisor/[org_id]/manage/benchmarks/index.vue?macro=true";
import { default as indexiptE7p_ELZaISm_8sPZObh4JTmvc0QvNzeh7K9F3jqMMeta } from "/app/app/pages/advisor/[org_id]/manage/calculations/index.vue?macro=true";
import { default as indexwRBAnZpnAIjwgXiyJOo48zuIWc5rckladgciz6sSwV0Meta } from "/app/app/pages/advisor/[org_id]/manage/integrations/index.vue?macro=true";
import { default as indexeOqueT_g7qQ7_deSIcO8_BAF2DpHKx_HS_Vt47otovwMeta } from "/app/app/pages/advisor/[org_id]/manage/njorda/index.vue?macro=true";
import { default as indexzzyjCucnTqbUitDkLwzrSB5qkQpFaSue93ERmfaDotkMeta } from "/app/app/pages/advisor/[org_id]/manage/portfolio-templates/index.vue?macro=true";
import { default as indexTa70e7ElzgRwgMwHtcStpW4c_A77VKfhaLZG9pBBa3QMeta } from "/app/app/pages/advisor/[org_id]/manage/product-list-allocations/index.vue?macro=true";
import { default as indexH60iB1PfghK2tfEGuB3VB4O8RUCaTHyplBhx4AysewAMeta } from "/app/app/pages/advisor/[org_id]/manage/product-lists/index.vue?macro=true";
import { default as indexJu5KvEqL_t7LWbBFRYVe1N_9e_ItpdsRfEeGYTGvBuQMeta } from "/app/app/pages/advisor/[org_id]/manage/risk-scenarios/index.vue?macro=true";
import { default as indexezCPixPQTrR7YzFu4VfaB4JJysMHhUfs25m47Q20PbgMeta } from "/app/app/pages/advisor/[org_id]/manage/settings/index.vue?macro=true";
import { default as indexhd91ZQgW_niC4sWMXAag_wmbIxo24a5RhXpKUmG0N_cMeta } from "/app/app/pages/advisor/[org_id]/manage/users/index.vue?macro=true";
import { default as newpfpzfanAMsjZ_BcmiB3_DqgIsm1Nf2_yl_Yk_aM5N84Meta } from "/app/app/pages/advisor/[org_id]/portfolio-builder/new.vue?macro=true";
import { default as bad_45orgx6_LF3687axYkRgNQ8s0PEGscchHNaVeFpz09twj0yEMeta } from "/app/app/pages/client/[org_id]/error/bad-org.vue?macro=true";
import { default as bad_45org9OGnZzz1KpwjxebFjFsiYZpolzlU2gyWv_6x_1ba3oAMeta } from "/app/app/pages/product-demo/[org_id]/error/bad-org.vue?macro=true";
import { default as _91position_id_93H8TNhuKGy8HuIORLW5x8BxXRzmwAP7vJWM_DNZJDLWsMeta } from "/app/app/pages/advisor/[org_id]/clients/[client_id]/account/[account_id]/position/[position_id].vue?macro=true";
import { default as indexuil8l2YcbcNSz0sUHDrrpwcMr_MveTur9_GfzqFTOg4Meta } from "/app/app/pages/advisor/[org_id]/clients/[client_id]/account/[account_id]/index.vue?macro=true";
import { default as _91report_id_93oP1OisNT6n7n4XlMqMyF4qApadHsQLPfkHsV3VEx_48Meta } from "/app/app/pages/advisor/[org_id]/clients/[client_id]/report/[report_id].vue?macro=true";
import { default as editVKyz7_CvlRtqYQs4lRK01mwzU_SgQiTxj4nFjW3kUWkMeta } from "/app/app/pages/advisor/[org_id]/clients/[client_id]/edit.vue?macro=true";
import { default as indexCOhzIzBH9IAudh0mwy2GjBCD1OC4fdMrKx__YxRGtgYMeta } from "/app/app/pages/advisor/[org_id]/clients/[client_id]/index.vue?macro=true";
import { default as _91proposal_id_93Lu8Eb62fKkMhDTRS1xC86bW93QClWTJW4trK10eLUG0Meta } from "/app/app/pages/advisor/[org_id]/portfolio-builder/[proposal_id].vue?macro=true";
import { default as _91id_93G5LGE9wDKvV5CreTFpfhN6prw_Mok88NXAMiq9XSk7UMeta } from "/app/app/pages/client/[org_id]/portfolio-report/[id].vue?macro=true";
import { default as indexr8ZJtBoHAlniADQH_MCU7ghVybRv62URm6jHEj2cIvMMeta } from "/app/app/pages/advisor/[org_id]/analytics/index.vue?macro=true";
import { default as indexKwcyBDMTzK9gdI1FzTbDXx4wjhjy_hMLIsjRQVW4J_oMeta } from "/app/app/pages/advisor/[org_id]/clients/index.vue?macro=true";
import { default as loginuJZRLNjeGgy9Dxt07QQo_FXmynPp0TEnqPrw4O8j0OMMeta } from "/app/app/pages/advisor/[org_id]/login.vue?macro=true";
import { default as index4sUw2zwGLQLEq4dQCJspoW_E4ZsMJgW9D_VmbmL4gL8Meta } from "/app/app/pages/advisor/[org_id]/portfolio-builder/index.vue?macro=true";
import { default as report_45donexnNy5l84tDp6HvqGdG_BGLl9Jt__GRI_KuAMakGpAJ0Meta } from "/app/app/pages/client/[org_id]/report-done.vue?macro=true";
import { default as start_45holdings_45collectioni3DiXWZv6Sn1cMcr8LgrD40p_TrVaQ3hcyuQAUffAAwMeta } from "/app/app/pages/client/[org_id]/start-holdings-collection.vue?macro=true";
import { default as terms_45and_45conditionsCzYyrDyMYdpHfwvnrAO15_lUA6UYCk4AtRUDDdfGqmUMeta } from "/app/app/pages/client/[org_id]/terms-and-conditions.vue?macro=true";
import { default as index9nhgAA1ZpdBZEiFOhSCtpum4jxUoUfItTxqhQ43wr_8Meta } from "/app/app/pages/advisor/[org_id]/index.vue?macro=true";
import { default as _91uuid_93gtQaHpXMLvlwEV7vU_WjPyJD62oVow9qw1zUhsCjsE8Meta } from "/app/app/pages/reset-password/[uuid].vue?macro=true";
import { default as indexSl1DH_1AdS0aIIKUoEisD4HvJ_gN1iXGfjJ_Q8FcJvQMeta } from "/app/app/pages/advisor/index.vue?macro=true";
import { default as indexHHPxwxQVve2KxZwOnBIHHhUEVxlsHsJGg6bm6A1NLJcMeta } from "/app/app/pages/developer/index.vue?macro=true";
import { default as forget_45passwordy7_fZp0E_fhZDMoY6rQdHTKiBZBearK4xQdcuyszazwMeta } from "/app/app/pages/forget-password.vue?macro=true";
import { default as logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta } from "/app/app/pages/login.vue?macro=true";
import { default as logout2OMJkScAmUDOL6_uAnnKkIkqlwTKTGCfC_SvfMsXjp4Meta } from "/app/app/pages/logout.vue?macro=true";
import { default as maintenanceB0dPhdEyV88_MoClqO_e6VO_RgGIumEnK1cdoU0zHTYMeta } from "/app/app/pages/maintenance.vue?macro=true";
import { default as test_45linksWotDeDZ3WmNPxBvzy_Vu7mSjPsKI2e3o8CL6S6Ht0EMMeta } from "/app/app/pages/test-links.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
export default [
  {
    name: "developer-ai-run-eval",
    path: "/developer/ai/run-eval",
    meta: { ...(run_45evalatXbv_L2h8jWiWGykSilI1p8Py_G4T5LzeBYo8cIaewMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/ai/run-eval.vue")
  },
  {
    name: "developer-ai-tools",
    path: "/developer/ai/tools",
    meta: { ...(toolsAEMtgpDusaSV8GInO2MnhIgvC2hhzwww9Iox_wJEOlMMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/ai/tools.vue")
  },
  {
    name: "developer-api-admin",
    path: "/developer/api/admin",
    meta: { ...(admin8RIdA2Ixao28P29uifxPEmy77bD6vQYb03cqFe6hVPMMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/api/admin.vue")
  },
  {
    name: "developer-api-app",
    path: "/developer/api/app",
    meta: { ...(appDc_ozAjZ_sNADGHkiOaq9F66HVRiR7eTYbPvFXJV16AMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/api/app.vue")
  },
  {
    name: "developer-api-b2b",
    path: "/developer/api/b2b",
    meta: { ...(b2bI2JTGrlMmXEifysoS5MqQPGC8qs9aiNETCneEuYANukMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/api/b2b.vue")
  },
  {
    name: "developer-api-b2b-v2",
    path: "/developer/api/b2b-v2",
    meta: { ...(b2b_45v2Q0vu1EZQCIkL6MU0VFV_jtPjtSx_Ofv2Hg0mXeW6cFAMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/api/b2b-v2.vue")
  },
  {
    name: "developer-api-connect",
    path: "/developer/api/connect",
    meta: { ...(connectXHnQtDPS924mUPs6n81HQ_QLuPmohV4urCQyekJto_UMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/api/connect.vue")
  },
  {
    name: "developer-api-mih",
    path: "/developer/api/mih",
    meta: { ...(miho40srN2p_NVIdvz4ZP7bmb92_rdYCPTx4HmmTtXTyFMMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/api/mih.vue")
  },
  {
    name: "embed-advisor-org_id-portfolio-builder-pdf",
    path: "/embed/advisor/:org_id()/portfolio-builder/pdf",
    meta: { ...(pdfeti_EK2qh9TTwSYnBJWFjZxY7_HAaok8cu7vh_D4b_kMeta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/embed/advisor/[org_id]/portfolio-builder/pdf.vue")
  },
  {
    name: "embed-advisor-org_id-portfolio-builder",
    path: "/embed/advisor/:org_id()/portfolio-builder",
    meta: { ...(index6eTU3gEqJRH80AiO4TXqdAA1f_h0SAI0aw_crKxyyYsMeta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/embed/advisor/[org_id]/portfolio-builder/index.vue")
  },
  {
    name: "developer-ai-id",
    path: "/developer/ai/:id()",
    meta: { ...(_91id_938fKS6NCYkbg6rL883FzdTbdmKqUu2bJid1ov9V53nKYMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/ai/[id].vue")
  },
  {
    name: "developer-maintenance-id",
    path: "/developer/maintenance/:id()",
    meta: { ...(_91id_93zzFCNlBnokH8j8X_qolTroP9DTN25FPXVNqniY3d1G8Meta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/maintenance/[id].vue")
  },
  {
    name: "developer-ai",
    path: "/developer/ai",
    meta: { ...(indexoL1Vtz0EZ0sCxYkTsLvo8_dKJ8ukdGCWa4ccmZAZhZQMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/ai/index.vue")
  },
  {
    name: "developer-client-details",
    path: "/developer/client-details",
    meta: { ...(client_45details2GzqUu0iE1D_NN7mhFWhErgsUtmAurP7ev8vXYhviosMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/client-details.vue")
  },
  {
    name: "developer-component-gallery",
    path: "/developer/component-gallery",
    meta: { ...(component_45galleryv5F9UAvyraRXaMMzu9K6Ae4pcdJTkOntILGAJwPv54IMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/component-gallery.vue")
  },
  {
    name: "developer-data-reports",
    path: "/developer/data-reports",
    meta: { ...(data_45reportsC0XDdP5gJrjakUKzjCABLfYI1K_Aare_qKPsIIZpBiQMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/data-reports.vue")
  },
  {
    name: "developer-data-sessions",
    path: "/developer/data-sessions",
    meta: { ...(data_45sessionsSZ8UeMLh9uvaT7Wbz5i3m_58_Uv15kbJCwxYVcWS7u8Meta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/data-sessions.vue")
  },
  {
    name: "developer-embed",
    path: "/developer/embed",
    meta: { ...(embedezdD_a6EC3GSPM4npTlddm_RxsmrXSheEHjJAOos_AsMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/embed.vue")
  },
  {
    name: "developer-holdings-report",
    path: "/developer/holdings-report",
    meta: { ...(holdings_45reportdNjogzmnrSiCFiFAtn3jh9FXqxph8DHMEzWeyIEmQ5EMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/holdings-report.vue")
  },
  {
    name: "developer-instrument-details",
    path: "/developer/instrument-details",
    meta: { ...(instrument_45detailshU4NR1ADzX1a0zfj5DKf8Af_FHtFtM_wSNn1N2dMti0Meta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/instrument-details.vue")
  },
  {
    name: "developer-instrument-issues",
    path: "/developer/instrument-issues",
    meta: { ...(instrument_45issuesKmfK58bE1w_rASMPLsCoXZgSPQDIk_xBv0WpCFF_8agMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/instrument-issues.vue")
  },
  {
    name: "developer-instrument-list",
    path: "/developer/instrument-list",
    meta: { ...(instrument_45list0Faubr0luTsCbJeBb3UkQ2hviWfqwDE0QMZNmuNElYEMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/instrument-list.vue")
  },
  {
    name: "developer-integration-tests",
    path: "/developer/integration-tests",
    meta: { ...(integration_45testsXBaq45LloJXAHpZk1QpPnI4X_Uz13dnQzQw_j2u_SqUMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/integration-tests.vue")
  },
  {
    name: "developer-integration-tests-report",
    path: "/developer/integration-tests-report",
    meta: { ...(integration_45tests_45reportmYUVBQowdIyIgC0QgHK_blV9Lh0LY_XZmaVSS0pipC8Meta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/integration-tests-report.vue")
  },
  {
    name: "developer-login",
    path: "/developer/login",
    meta: loginHDi2XHV6t5wgi5ZIsE1Qps7YFhvpbI1L9Trkffa7Ea0Meta || {},
    component: () => import("/app/app/pages/developer/login.vue")
  },
  {
    name: "developer-maintenance",
    path: "/developer/maintenance",
    meta: { ...(indexeJew_SAgG9UrFYhzdvm7M73L3WEA4Vq_yiy62naIDZAMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/maintenance/index.vue")
  },
  {
    name: "developer-market-data",
    path: "/developer/market-data",
    meta: { ...(market_45datag_CeMLSvldIUJ_EtsclyNElzcOImhslS1zPnyXPafwoMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/market-data.vue")
  },
  {
    name: "developer-organizations",
    path: "/developer/organizations",
    meta: { ...(organizationsx94E7dqhE68Sk_cBy2RSgZJei3x8kF_Yo75VAVBiPAsMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/organizations.vue")
  },
  {
    name: "developer-portfolio-data",
    path: "/developer/portfolio-data",
    meta: { ...(portfolio_45datapwOr_fffJ6mOLmdLUouQztNjo5nnVoTfJ8bv2jivuiYMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/portfolio-data.vue")
  },
  {
    name: "developer-price-anomalies",
    path: "/developer/price-anomalies",
    meta: { ...(price_45anomaliesGsLFzMqDECf9yn86XPCOwQuM5TwrdivjYZzWD75eBzkMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/price-anomalies.vue")
  },
  {
    name: "developer-trigger-task",
    path: "/developer/trigger-task",
    meta: { ...(trigger_45tasknoXWIUuoqMmbQ9ETagzj0o_8wVUvLzRVEQ7Gr7nF6nYMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/trigger-task.vue")
  },
  {
    name: "developer-user-details",
    path: "/developer/user-details",
    meta: { ...(user_45detailsTgjvsSJql6gcRSo9AEgsZk47VxE5beAEKh2_jGljI_sMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/user-details.vue")
  },
  {
    name: "developer-user-list",
    path: "/developer/user-list",
    meta: { ...(user_45listAtyb83ThhclAUoZ_iHLvUxfho7m9H5LopOatupd51kYMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/user-list.vue")
  },
  {
    name: "docs-api",
    path: "/docs/api",
    meta: apin4EqGWUbQ9rgKVBTjxE3vj2pSNx_ok9qVNapqHu6P8UMeta || {},
    component: () => import("/app/app/pages/docs/api.vue")
  },
  {
    name: "advisor-org_id-analytics-reports-new",
    path: "/advisor/:org_id()/analytics/reports/new",
    meta: { ...(newHSpNmtD_Ulst0gnQ0JT3hF856X8B_vJNwfg7w3nrvx0Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/analytics/reports/new.vue")
  },
  {
    name: "advisor-org_id-manage-njorda-app",
    path: "/advisor/:org_id()/manage/njorda/app",
    meta: { ...(appjuok_UjUXSYQAfdIjvWRLC_N6Q_8qA2WkjsSAOh_x2MMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/njorda/app.vue")
  },
  {
    name: "advisor-org_id-manage-users-new",
    path: "/advisor/:org_id()/manage/users/new",
    meta: { ...(newnNSjzc73WskL_YsmU3a1xr3mcodA87YvBGGP6yRRWvIMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/users/new.vue")
  },
  {
    name: "advisor-org_id-manage-users-user_id-edit",
    path: "/advisor/:org_id()/manage/users/:user_id()/edit",
    meta: { ...(editqiR0GEPfLQeQtmy9tIdVDB5H_C6WVhrDH4u3X84wITEMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/users/[user_id]/edit.vue")
  },
  {
    name: "advisor-org_id-analytics-reports-report_id",
    path: "/advisor/:org_id()/analytics/reports/:report_id()",
    meta: { ...(_91report_id_93K2JPE3C885asztl_PdvxfIvC5bRle64ryIl9cF66_KAMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/analytics/reports/[report_id].vue")
  },
  {
    name: "advisor-org_id-manage-users-user_id",
    path: "/advisor/:org_id()/manage/users/:user_id()",
    meta: { ...(indexV4hCtGPMvJgJFYSfLF_ovwF22dfuEXtuMhCLITKt0d8Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/users/[user_id]/index.vue")
  },
  {
    name: "client-org_id-portfolio-sharing-start-id",
    path: "/client/:org_id()/portfolio-sharing/start/:id()",
    meta: { ...(_91id_93q_K5_wxkY7_sRiVRcBqaCZKYCJv7TFEMp9xwxhbW6vEMeta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/client/[org_id]/portfolio-sharing/start/[id].vue")
  },
  {
    name: "client-org_id-portfolio-sharing-step-1-id",
    path: "/client/:org_id()/portfolio-sharing/step-1/:id()",
    meta: { ...(_91id_93Qguui0HqoEC7D_xDNzk81thn1OGKwCbWwC9P6bC1KjEMeta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/client/[org_id]/portfolio-sharing/step-1/[id].vue")
  },
  {
    name: "client-org_id-portfolio-sharing-step-2-id",
    path: "/client/:org_id()/portfolio-sharing/step-2/:id()",
    meta: { ...(_91id_93eYUiz8CKd0XbCZC5jsBrY3jDu8xN_sJfmc7brXM_Jh4Meta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/client/[org_id]/portfolio-sharing/step-2/[id].vue")
  },
  {
    name: "product-demo-org_id-mb-report-id",
    path: "/product-demo/:org_id()/mb/report/:id()",
    meta: { ...(_91id_93ojnSr2VLejvCfRIWm_dzbBjKIueqUUDoM31E6qN2GboMeta || {}), ...{"middleware":"my-benefit-demo-access-required"} },
    component: () => import("/app/app/pages/product-demo/[org_id]/mb/report/[id].vue")
  },
  {
    name: "product-demo-org_id-mb-review-id",
    path: "/product-demo/:org_id()/mb/review/:id()",
    meta: { ...(_91id_93ldtR2WA8muEs3TlN0_caKj5GF5qfoXo0gbx3Kd1D5dUMeta || {}), ...{"middleware":"my-benefit-demo-access-required"} },
    component: () => import("/app/app/pages/product-demo/[org_id]/mb/review/[id].vue")
  },
  {
    name: "advisor-org_id-analytics-reports",
    path: "/advisor/:org_id()/analytics/reports",
    meta: { ...(indexQOICDPbq4Gu86twmjGivB_i8VLoENmyKNbOKOKmaw8kMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/analytics/reports/index.vue")
  },
  {
    name: "advisor-org_id-clients-new",
    path: "/advisor/:org_id()/clients/new",
    meta: { ...(newAQG2i4lgjMf8AAZUnbWlBB_R17u0a6ZyIUQNhfJHE_8Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/new.vue")
  },
  {
    name: "advisor-org_id-manage-asset-class-rules",
    path: "/advisor/:org_id()/manage/asset-class-rules",
    meta: { ...(indexekhNpJOHVRQ_KKv05stgmDxclAw_xwAxHR1aZzOVjogMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/asset-class-rules/index.vue")
  },
  {
    name: "advisor-org_id-manage-asset-classes",
    path: "/advisor/:org_id()/manage/asset-classes",
    meta: { ...(indexDF7hfdZl560pWMFqz_xY5LPx6q_PPTRo06aG0PNGjE4Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/asset-classes/index.vue")
  },
  {
    name: "advisor-org_id-manage-benchmarks",
    path: "/advisor/:org_id()/manage/benchmarks",
    meta: { ...(indexPNfkdRK95UUzJR7H32997zO3dIuclrp_eLmOUKGOua0Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/benchmarks/index.vue")
  },
  {
    name: "advisor-org_id-manage-calculations",
    path: "/advisor/:org_id()/manage/calculations",
    meta: { ...(indexiptE7p_ELZaISm_8sPZObh4JTmvc0QvNzeh7K9F3jqMMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/calculations/index.vue")
  },
  {
    name: "advisor-org_id-manage-integrations",
    path: "/advisor/:org_id()/manage/integrations",
    meta: { ...(indexwRBAnZpnAIjwgXiyJOo48zuIWc5rckladgciz6sSwV0Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/integrations/index.vue")
  },
  {
    name: "advisor-org_id-manage-njorda",
    path: "/advisor/:org_id()/manage/njorda",
    meta: { ...(indexeOqueT_g7qQ7_deSIcO8_BAF2DpHKx_HS_Vt47otovwMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/njorda/index.vue")
  },
  {
    name: "advisor-org_id-manage-portfolio-templates",
    path: "/advisor/:org_id()/manage/portfolio-templates",
    meta: { ...(indexzzyjCucnTqbUitDkLwzrSB5qkQpFaSue93ERmfaDotkMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/portfolio-templates/index.vue")
  },
  {
    name: "advisor-org_id-manage-product-list-allocations",
    path: "/advisor/:org_id()/manage/product-list-allocations",
    meta: { ...(indexTa70e7ElzgRwgMwHtcStpW4c_A77VKfhaLZG9pBBa3QMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/product-list-allocations/index.vue")
  },
  {
    name: "advisor-org_id-manage-product-lists",
    path: "/advisor/:org_id()/manage/product-lists",
    meta: { ...(indexH60iB1PfghK2tfEGuB3VB4O8RUCaTHyplBhx4AysewAMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/product-lists/index.vue")
  },
  {
    name: "advisor-org_id-manage-risk-scenarios",
    path: "/advisor/:org_id()/manage/risk-scenarios",
    meta: { ...(indexJu5KvEqL_t7LWbBFRYVe1N_9e_ItpdsRfEeGYTGvBuQMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/risk-scenarios/index.vue")
  },
  {
    name: "advisor-org_id-manage-settings",
    path: "/advisor/:org_id()/manage/settings",
    meta: { ...(indexezCPixPQTrR7YzFu4VfaB4JJysMHhUfs25m47Q20PbgMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/settings/index.vue")
  },
  {
    name: "advisor-org_id-manage-users",
    path: "/advisor/:org_id()/manage/users",
    meta: { ...(indexhd91ZQgW_niC4sWMXAag_wmbIxo24a5RhXpKUmG0N_cMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/manage/users/index.vue")
  },
  {
    name: "advisor-org_id-portfolio-builder-new",
    path: "/advisor/:org_id()/portfolio-builder/new",
    meta: { ...(newpfpzfanAMsjZ_BcmiB3_DqgIsm1Nf2_yl_Yk_aM5N84Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/portfolio-builder/new.vue")
  },
  {
    name: "client-org_id-error-bad-org",
    path: "/client/:org_id()/error/bad-org",
    meta: bad_45orgx6_LF3687axYkRgNQ8s0PEGscchHNaVeFpz09twj0yEMeta || {},
    component: () => import("/app/app/pages/client/[org_id]/error/bad-org.vue")
  },
  {
    name: "product-demo-org_id-error-bad-org",
    path: "/product-demo/:org_id()/error/bad-org",
    meta: bad_45org9OGnZzz1KpwjxebFjFsiYZpolzlU2gyWv_6x_1ba3oAMeta || {},
    component: () => import("/app/app/pages/product-demo/[org_id]/error/bad-org.vue")
  },
  {
    name: "advisor-org_id-clients-client_id-account-account_id-position-position_id",
    path: "/advisor/:org_id()/clients/:client_id()/account/:account_id()/position/:position_id()",
    meta: { ...(_91position_id_93H8TNhuKGy8HuIORLW5x8BxXRzmwAP7vJWM_DNZJDLWsMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/[client_id]/account/[account_id]/position/[position_id].vue")
  },
  {
    name: "advisor-org_id-clients-client_id-account-account_id",
    path: "/advisor/:org_id()/clients/:client_id()/account/:account_id()",
    meta: { ...(indexuil8l2YcbcNSz0sUHDrrpwcMr_MveTur9_GfzqFTOg4Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/[client_id]/account/[account_id]/index.vue")
  },
  {
    name: "advisor-org_id-clients-client_id-report-report_id",
    path: "/advisor/:org_id()/clients/:client_id()/report/:report_id()",
    meta: { ...(_91report_id_93oP1OisNT6n7n4XlMqMyF4qApadHsQLPfkHsV3VEx_48Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/[client_id]/report/[report_id].vue")
  },
  {
    name: "advisor-org_id-clients-client_id-edit",
    path: "/advisor/:org_id()/clients/:client_id()/edit",
    meta: { ...(editVKyz7_CvlRtqYQs4lRK01mwzU_SgQiTxj4nFjW3kUWkMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/[client_id]/edit.vue")
  },
  {
    name: "advisor-org_id-clients-client_id",
    path: "/advisor/:org_id()/clients/:client_id()",
    meta: { ...(indexCOhzIzBH9IAudh0mwy2GjBCD1OC4fdMrKx__YxRGtgYMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/[client_id]/index.vue")
  },
  {
    name: "advisor-org_id-portfolio-builder-proposal_id",
    path: "/advisor/:org_id()/portfolio-builder/:proposal_id()",
    meta: { ...(_91proposal_id_93Lu8Eb62fKkMhDTRS1xC86bW93QClWTJW4trK10eLUG0Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/portfolio-builder/[proposal_id].vue")
  },
  {
    name: "client-org_id-portfolio-report-id",
    path: "/client/:org_id()/portfolio-report/:id()",
    meta: { ...(_91id_93G5LGE9wDKvV5CreTFpfhN6prw_Mok88NXAMiq9XSk7UMeta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/client/[org_id]/portfolio-report/[id].vue")
  },
  {
    name: "advisor-org_id-analytics",
    path: "/advisor/:org_id()/analytics",
    meta: {"middleware":["login-required","advisor-access-required"]},
    component: () => import("/app/app/pages/advisor/[org_id]/analytics/index.vue")
  },
  {
    name: "advisor-org_id-clients",
    path: "/advisor/:org_id()/clients",
    meta: { ...(indexKwcyBDMTzK9gdI1FzTbDXx4wjhjy_hMLIsjRQVW4J_oMeta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/clients/index.vue")
  },
  {
    name: "advisor-org_id-login",
    path: "/advisor/:org_id()/login",
    meta: loginuJZRLNjeGgy9Dxt07QQo_FXmynPp0TEnqPrw4O8j0OMMeta || {},
    component: () => import("/app/app/pages/advisor/[org_id]/login.vue")
  },
  {
    name: "advisor-org_id-portfolio-builder",
    path: "/advisor/:org_id()/portfolio-builder",
    meta: { ...(index4sUw2zwGLQLEq4dQCJspoW_E4ZsMJgW9D_VmbmL4gL8Meta || {}), ...{"middleware":["login-required","advisor-access-required"]} },
    component: () => import("/app/app/pages/advisor/[org_id]/portfolio-builder/index.vue")
  },
  {
    name: "client-org_id-report-done",
    path: "/client/:org_id()/report-done",
    meta: { ...(report_45donexnNy5l84tDp6HvqGdG_BGLl9Jt__GRI_KuAMakGpAJ0Meta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/client/[org_id]/report-done.vue")
  },
  {
    name: "client-org_id-start-holdings-collection",
    path: "/client/:org_id()/start-holdings-collection",
    meta: { ...(start_45holdings_45collectioni3DiXWZv6Sn1cMcr8LgrD40p_TrVaQ3hcyuQAUffAAwMeta || {}), ...{"middleware":"advisor-access-required"} },
    component: () => import("/app/app/pages/client/[org_id]/start-holdings-collection.vue")
  },
  {
    name: "client-org_id-terms-and-conditions",
    path: "/client/:org_id()/terms-and-conditions",
    meta: terms_45and_45conditionsCzYyrDyMYdpHfwvnrAO15_lUA6UYCk4AtRUDDdfGqmUMeta || {},
    component: () => import("/app/app/pages/client/[org_id]/terms-and-conditions.vue")
  },
  {
    name: "advisor-org_id",
    path: "/advisor/:org_id()",
    meta: {"middleware":["login-required","advisor-access-required"]},
    component: () => import("/app/app/pages/advisor/[org_id]/index.vue")
  },
  {
    name: "reset-password-uuid",
    path: "/reset-password/:uuid()",
    meta: _91uuid_93gtQaHpXMLvlwEV7vU_WjPyJD62oVow9qw1zUhsCjsE8Meta || {},
    component: () => import("/app/app/pages/reset-password/[uuid].vue")
  },
  {
    name: "advisor",
    path: "/advisor",
    meta: {"middleware":["login-required"]},
    component: () => import("/app/app/pages/advisor/index.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: { ...(indexHHPxwxQVve2KxZwOnBIHHhUEVxlsHsJGg6bm6A1NLJcMeta || {}), ...{"middleware":"developer-super-admin-required"} },
    component: () => import("/app/app/pages/developer/index.vue")
  },
  {
    name: "forget-password",
    path: "/forget-password",
    meta: forget_45passwordy7_fZp0E_fhZDMoY6rQdHTKiBZBearK4xQdcuyszazwMeta || {},
    component: () => import("/app/app/pages/forget-password.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logint39C9hu31ZqlmicAcLzdLRsvi__ZDDIjJh0PFbnWqs8Meta || {},
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/app/app/pages/logout.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceB0dPhdEyV88_MoClqO_e6VO_RgGIumEnK1cdoU0zHTYMeta || {},
    component: () => import("/app/app/pages/maintenance.vue")
  },
  {
    name: "test-links",
    path: "/test-links",
    meta: test_45linksWotDeDZ3WmNPxBvzy_Vu7mSjPsKI2e3o8CL6S6Ht0EMMeta || {},
    component: () => import("/app/app/pages/test-links.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":"login-required"},
    component: () => import("/app/app/pages/index.vue")
  }
]